module.exports = __webpack_public_path__ + "img/violet_034.8920efff.png";